const KeenSlider = window.KeenSlider

class HeaderAnnouncementBar extends window.BAO.CarouselElement {
  constructor () {
    super()

    this.isTicking = false
    // eslint-disable-next-line
    this.lastKnownY = window.scrollY
    this.offsetTrackedY = 0
    this.scrollOffset = 100
    this.safeZone = 50
    this.scrollDirection = ''

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  connectedCallback () {
    super.connectedCallback()
    this.settings = {
      autoplay: true,
      autoplayFrequencey: 5000,
    }
    this.carousel = this.initialiseCarousel()

    this.setHeight()
  }

  setupListeners () {
    super.setupListeners()
    this.debouncedOnResize = window.BAO.Utils.debounce(event => {
      this.handleResize(event)
    }, 250)
    this.listeners.add(window, 'resize', this.debouncedOnResize.bind(this))

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  initialiseCarousel () {
    if (!this.els?.slides?.exists || !this.els?.slide?.exists) return
    return new KeenSlider(this.els.slides.element, {
      selector: this.els.slide.selector,
      drag: true,
      loop: true,
      mode: 'snap',
      rubberband: false,
      slides: {
        origin: 'auto',
        perView: 1,
        spacing: 0,
      },
    })
  }

  onScroll () {
    const previouslyKnown = this.lastKnownY
    const previousDirection = this.scrollDirection

    // eslint-disable-next-line
    this.lastKnownY = window.scrollY
    this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up'

    if (previousDirection !== this.scrollDirection) {
      this.offsetTrackedY = this.lastKnownY
    }

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setSize()
    this.setIsScrolled()
    this.toggleScrollDirectionClass()
  }

  setSize () {
    this.bodyContainer.classList.toggle('hd-Header-small', this.headerIsSmaller)
  }

  setIsScrolled () {
    const isScrolled = window.scrollY !== 0

    this.bodyContainer.classList.toggle('hd-Header-scrolled', isScrolled)
  }

  toggleScrollDirectionClass () {
    const body = this.bodyContainer

    if (this.lastKnownY === 0) return

    if (this.scrollDirection === 'down' && this.lastKnownY <= 50) {
      return
    }

    const directionClass =
      this.scrollDirection === 'down'
        ? 'hd-Header-scrolled-down'
        : 'hd-Header-scrolled-up'

    if (body.classList.contains(directionClass)) return

    body.classList.remove('hd-Header-scrolled-up', 'hd-Header-scrolled-down')
    body.classList.add(directionClass)
  }

  get shouldBeVisible () {
    if (this.lastKnownY <= this.offsetHeight + this.safeZone * 2) {
      return true
    }

    if (this.scrollDirection === 'down') {
      return !this.isOverOffset
    } else if (this.scrollDirection === 'up') {
      return this.isOverOffset
    }
  }

  get isOverOffset () {
    if (this.scrollDirection === 'down') {
      return this.lastKnownY >= this.offsetTrackedY + this.scrollOffset
    } else if (this.scrollDirection === 'up') {
      return this.lastKnownY <= this.offsetTrackedY - this.scrollOffset
    }
  }

  get headerIsSmaller () {
    return this.lastKnownY > this.safeZone
  }

  get bodyContainer () {
    return document.body
  }

  handleResize () {
    document.body.style.setProperty(
      '--Announcement_Height',
      `${this.annoucementBodyHeight}px`,
    )
  }

  setHeight () {
    setTimeout(() => {
      if (this.annoucementBodyHeight > this.initialHeight) {
        document.body.style.setProperty(
          '--Announcement_Height',
          `${this.annoucementBodyHeight}px`,
        )
      }
    }, 500)
  }

  get annoucementBodyHeight () {
    return this.els?.container?.element.getBoundingClientRect().height
  }

  get initialHeight () {
    return getComputedStyle(document.body)
      .getPropertyValue('--Announcement_Height')
      .replace('px', '')
  }
}

if (!customElements.get('header-announcement-bar')) {
  customElements.define('header-announcement-bar', HeaderAnnouncementBar)
}
